import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { UPDATE_ROOM_URL } from "./api-url.constants";
import { UpdateRoomApiDto } from "./dtos/update-room.api.dto";
import {
  AvantioAccommodationAlreadyLinkedError,
  GuestyListingAlreadyLinkedError,
  IcneaPropertyAlreadyLinkedError,
  UpdateRoomError,
  UpdateRoomErpIntegrationsError,
} from "./errors";
import {
  AVANTIO_ACCOMMODATION_ALREADY_LINKED_ERROR_MESSAGE,
  GUESTY_LISTING_ALREADY_LINKED_ERROR_MESSAGE,
  ICNEA_PROPERTY_ALREADY_LINKED_ERROR_MESSAGE,
  UPDATE_ROOM_ERP_INTEGRATIONS_ERROR_MESSAGE,
} from "./errors/error-message.constants";

const extractConflictingRoomName = (message: string): string | undefined => {
  const match = message.match(/is already linked to another room:\s*(.+)$/);
  return match ? match[1].trim() : undefined;
};

export const updateRoom = async (updateRoomBodyApiDto: UpdateRoomApiDto): Promise<boolean> => {
  const { _id, ...body } = updateRoomBodyApiDto;
  const result = await typedFetch(`${UPDATE_ROOM_URL}/${_id}`, {
    method: API_METHODS.PUT,
    body: JSON.stringify(body),
  });

  if (result.ok) return true;

  const responseJson = await result.json();

  if ("error" in responseJson) {
    const message = Array.isArray(responseJson.message)
      ? responseJson.message[0]
      : responseJson.message;
    if (message === UPDATE_ROOM_ERP_INTEGRATIONS_ERROR_MESSAGE)
      throw new UpdateRoomErpIntegrationsError();
    if (message.includes(GUESTY_LISTING_ALREADY_LINKED_ERROR_MESSAGE)) {
      throw new GuestyListingAlreadyLinkedError(extractConflictingRoomName(message));
    }
    if (message.includes(AVANTIO_ACCOMMODATION_ALREADY_LINKED_ERROR_MESSAGE)) {
      throw new AvantioAccommodationAlreadyLinkedError(extractConflictingRoomName(message));
    }
    if (message.includes(ICNEA_PROPERTY_ALREADY_LINKED_ERROR_MESSAGE)) {
      throw new IcneaPropertyAlreadyLinkedError(extractConflictingRoomName(message));
    }
    // Default error
    throw new UpdateRoomError();
  }

  return true;
};
